(function () {
  'use strict';
  var current = '', timer;
  var proximity = window.DCProximity;
  function location() { return proximity.location(); }
  function city(el) {
    if ((el.dataset.city || '').trim()) return (el.dataset.city || '').trim();
    var parts = (el.dataset.address || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (/^(españa|spain)$/i.test(parts[parts.length - 1] || '')) parts.pop();
    var postal = parts.find(function (s) { return /^\d{5}\s+\D/.test(s); });
    if (postal) return postal.replace(/^\d{5}\s+/, '').trim();
    var candidate = parts.length >= 3 ? parts[parts.length - 2] : '';
    return candidate && !/^\d|^(calle|avenida|avda|plaza|paseo|carretera)\b/i.test(candidate) ? candidate : '';
  }
  function paint(el, loc) {
    // Professional portal cards retain their own design.
    if (el.closest('[id="dulchefs-portal-root"], .dc-professional-portal')) { el.hidden = true; return; }
    var name = city(el), km = loc ? proximity.value(loc, el.dataset.owner) : undefined;
    var text = (Number.isFinite(km) ? String(km < 10 ? km.toFixed(1) : Math.round(km)).replace('.', ',') + ' km' + (name ? ' · ' : '') : '') + name;
    if (el.hasAttribute('data-dc-detail-place')) {
      var address = (el.dataset.address || '').trim().replace(/,\s*(?:España|Spain|ES)\s*$/i, '').trim() || name;
      text = address + (Number.isFinite(km) ? (address ? ' · ' : '') + 'A ' + String(km < 10 ? km.toFixed(1) : Math.round(km)).replace('.', ',') + ' km. de tu ubicación' : '');
    }
    if (el.textContent !== text) el.textContent = text;
    el.hidden = !text;
    el.title = Number.isFinite(km) ? 'Distancia aproximada en línea recta desde la ubicación seleccionada' : ''; 
  }
  function refresh() {
    var loc = location(), key = loc ? loc.lat + ',' + loc.lng : '';
    current = key;
    var elements = Array.from(document.querySelectorAll('[data-dc-card-place]'));
    elements.forEach(function (el) { paint(el, loc); });
    if (!loc) return;
    var ids = elements.filter(function(el){return !el.closest('[id="dulchefs-portal-root"], .dc-professional-portal')}).map(function(el){return el.dataset.owner});
    proximity.ensure(ids,loc).then(function(){
      if(current!==key)return;
      document.querySelectorAll('[data-dc-card-place]').forEach(function(el){paint(el,loc)});
    }).catch(function(){ /* Keep locality; never invent a distance. */ });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 80); }
  document.addEventListener('dulchefs:locationchange', refresh);
  document.addEventListener('dulchefs:productsrendered', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('storage', function (event) { if (event.key === 'dulchefs_location_v2') refresh(); });
  new MutationObserver(function (records) {
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('[data-dc-card-place]') || n.querySelector('[data-dc-card-place]')); }); })) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  refresh();
})();
